import clsx from "clsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { Layout } from "../../../ui/layout";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { Calendar } from "../../../ui/molecules/calendar";
import InputMultiSearch from "../../../ui/molecules/input/InputMultiSearch";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { Pagination } from "../../../ui/organisms/pagination";
import { OptionType, entryMeansOptions, formatterDate, sot, yearOptions } from "../../../utils";
import { GetCustomerByCompanyNameResponseDTO, getCustomersByIdResponseDTO } from "../../clienti/dto";
import { GetCustomersByCompanyName, GetCustomersById } from "../../clienti/slice";
import { EntryListProtocol } from "./list";
import { GetAllEntryProtocolAttachments, GetAllEntryProtocolObjects, GetAllEntryProtocols, resetEntryProtocolCreationRequest, resetEntryProtocolCreationStatus, resetGetAllEPFilters, resetGetAllEntryProtocolAttachmentsStatus, resetGetAllEntryProtocolObjectsStatus, setGetAllEPFilterAttachmentId, setGetAllEPFilterClient, setGetAllEPFilterFrom, setGetAllEPFilterHeadquarter, setGetAllEPFilterNumber, setGetAllEPFilterObjectId, setGetAllEPFilterObjectSpec, setGetAllEPFilterPage, setGetAllEPFilterSender, setGetAllEPFilterTo, setGetAllEPFilterYear, setGetAllEPFilterentryMeans } from "./slice";

type CustomerSearchItem = GetCustomerByCompanyNameResponseDTO | getCustomersByIdResponseDTO

export function EntryProtocol() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const usersState = useAppSelector(state => state.users)
    const entryProtocolState = useAppSelector(state => state.entryProtocol)

    useEffect(() => {
        dispatch(resetEntryProtocolCreationRequest())
        dispatch(resetEntryProtocolCreationStatus())
    }, [])

    useEffect(() => {
        if (usersState.findMeStatus === 'successfully') {
            if (usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin') {
                dispatch(setGetAllEPFilterHeadquarter(usersState.findMeResponse.headQuarterInfo?.id))
            }
        }
    }, [usersState.findMeStatus])

    const [objects, setObjects] = useState<OptionType[]>([])
    const [attachments, setAttachments] = useState<OptionType[]>([])
    const [filtersResetVersion, setFiltersResetVersion] = useState<number>(0)

    const searchCustomers = async (query: string): Promise<CustomerSearchItem[]> => {
        const response = await dispatch(GetCustomersByCompanyName(query)).unwrap()
        return (response?.data ?? []) as CustomerSearchItem[]
    }

    const searchLeadCustomers = async (query: string): Promise<CustomerSearchItem[]> => {
        const response = await dispatch(GetCustomersByCompanyName({
            search: query,
            operatorsGroup: 'CAPOFILA'
        })).unwrap()
        return (response?.data ?? []) as CustomerSearchItem[]
    }

    const fetchCustomerById = async (id: string): Promise<CustomerSearchItem> => {
        const response = await dispatch(GetCustomersById(id)).unwrap()
        return response as CustomerSearchItem
    }

    useEffect(() => {
        dispatch(GetAllEntryProtocolObjects())
        dispatch(GetAllEntryProtocolAttachments({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolFilters.page !== undefined) {
            dispatch(GetAllEntryProtocols(entryProtocolState.getAllEntryProtocolFilters))
        }
    }, [entryProtocolState.getAllEntryProtocolFilters.page])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolObjectsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolObjectsStatus())
            const data = entryProtocolState.getAllEntryProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [entryProtocolState.getAllEntryProtocolObjectsStatus])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolAttachmentsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolAttachmentsStatus())
            const data = entryProtocolState.getAllEntryProtocolAttachmentsResponse
            const newAtts: OptionType[] = data.data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setAttachments(newAtts)
        }
    }, [entryProtocolState.getAllEntryProtocolAttachmentsStatus])

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Gestione Protocollo', 'Protocollo Entrata']}
            noPaddingLat
            headerLabel="Protocollo Entrata"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Aggiungi Protocollo Entrata"
                        color={"orange"}
                        onClick={() => {
                            navigate('/addEntryProtocol')
                        }}
                    />
                </div>
            }
        >
            <div className="w-[100%] flex flex-col gap-[16px] flex-grow" style={{ padding: '24px 24px 0px 24px' }}>
                <div className={"grid grid-cols-3 gap-4 items-start"}>
                    <MadfarmStaticSelect
                        isClearable
                        options={sot}
                        placeholder={"Sede / Ufficio"}
                        noOptionsMessage={"Nessun risultato trovato"}
                        label={"Sede/Ufficio"}
                        disabled={usersState.findMeResponse.headQuarterInfo?.code != 'SC' && usersState.findMeResponse.role != 'admin'}
                        value={entryProtocolState.getAllEntryProtocolFilters.headquarter}
                        defaultValue={entryProtocolState.getAllEntryProtocolFilters.headquarter}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllEPFilterHeadquarter(newValue))
                        }}
                    />
                    <MadfarmInput
                        label={'Numero'}
                        value={entryProtocolState.getAllEntryProtocolFilters.number}
                        placeholder="Specifica Numero"
                        onChangeText={(text) => { dispatch(setGetAllEPFilterNumber(text)) }}
                    />
                    <MadfarmStaticSelect
                        isClearable
                        label={"Anno"}
                        key={entryProtocolState.getAllEntryProtocolFilters.year || 'default'}
                        placeholder={'Anno'}
                        value={entryProtocolState.getAllEntryProtocolFilters.year}
                        options={yearOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllEPFilterYear(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                </div>
                <div className={"grid grid-cols-3 gap-4 items-start"}>
                    <MadfarmStaticSelect
                        isClearable
                        label={"Mezzo di Entrata"}
                        placeholder={'Seleziona'}
                        key={entryProtocolState.getAllEntryProtocolFilters.entryMeans || 'default'}
                        value={entryProtocolState.getAllEntryProtocolFilters.entryMeans}
                        options={entryMeansOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllEPFilterentryMeans(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                    <Calendar
                        label="Dal"
                        onClear={(date) => dispatch(setGetAllEPFilterFrom(date))}
                        selected={entryProtocolState.getAllEntryProtocolFilters.from}
                        onChange={(date) => dispatch(setGetAllEPFilterFrom(date))}
                    />
                    <Calendar
                        label="Al"
                        onClear={(date) => dispatch(setGetAllEPFilterTo(date))}
                        selected={entryProtocolState.getAllEntryProtocolFilters.to}
                        onChange={(date) => dispatch(setGetAllEPFilterTo(date))}
                    />
                </div>
                <div className={"grid grid-cols-3 gap-4 items-start"}>
                    <InputMultiSearch
                        key={`client-${filtersResetVersion}`}
                        searchOne
                        label={'Cliente'}
                        placeholder="Ragione sociale"
                        onSearch={searchCustomers}
                        onFetchById={fetchCustomerById}
                        getId={(customer) => customer.id}
                        renderResult={(customer, isSelected) => {
                            const isInactive = customer.endingDate !== null
                            return (
                                <div className="flex flex-col gap-0.5 items-start">
                                    <span
                                        className={clsx('font-semibold text-left', {
                                            'text-red-600': isInactive && !isSelected,
                                            'text-brandPrimary-700': !isInactive && !isSelected,
                                        })}
                                    >
                                        {customer.companyName}
                                    </span>
                                    <span className="text-xs text-neutral-600 text-left">
                                        {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                    </span>
                                    <span className="text-xs text-neutral-500 text-left">
                                        Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                    </span>
                                </div>
                            )
                        }}
                        renderSelected={(customer) => (
                            <div className="flex flex-col gap-0.5 flex-1 items-start">
                                <span className="text-sm font-bold text-brandPrimary-700 text-left">
                                    {customer.companyName}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                </span>
                            </div>
                        )}
                        defaultIds={entryProtocolState.getAllEntryProtocolFilters.client ? [entryProtocolState.getAllEntryProtocolFilters.client] : []}
                        onSelectAddHandler={(res) => {
                            dispatch(setGetAllEPFilterClient(res[0] ?? ''))
                        }}
                    />
                    <InputMultiSearch
                        key={`sender-${filtersResetVersion}`}
                        searchOne
                        label={'Mittente'}
                        placeholder="Ragione sociale"
                        onSearch={searchLeadCustomers}
                        onFetchById={fetchCustomerById}
                        getId={(customer) => customer.id}
                        renderResult={(customer, isSelected) => {
                            const isInactive = customer.endingDate !== null
                            return (
                                <div className="flex flex-col gap-0.5 items-start">
                                    <span
                                        className={clsx('font-semibold text-left', {
                                            'text-red-600': isInactive && !isSelected,
                                            'text-brandPrimary-700': !isInactive && !isSelected,
                                        })}
                                    >
                                        {customer.companyName}
                                    </span>
                                    <span className="text-xs text-neutral-600 text-left">
                                        {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                    </span>
                                    <span className="text-xs text-neutral-500 text-left">
                                        Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                    </span>
                                </div>
                            )
                        }}
                        renderSelected={(customer) => (
                            <div className="flex flex-col gap-0.5 flex-1 items-start">
                                <span className="text-sm font-bold text-brandPrimary-700 text-left">
                                    {customer.companyName}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                </span>
                            </div>
                        )}
                        onSelectAddHandler={(res) => {
                            if ((res?.length ?? 0) === 0) {
                                dispatch(setGetAllEPFilterSender(''))
                                return
                            }

                            void fetchCustomerById(res[0])
                                .then((customer) => {
                                    dispatch(setGetAllEPFilterSender(customer.companyName))
                                })
                                .catch(() => {
                                    dispatch(setGetAllEPFilterSender(''))
                                })
                        }}
                    />
                    <MadfarmStaticSelect
                        isClearable
                        label={"Allegato"}
                        placeholder={'Seleziona allegato'}
                        options={attachments}
                        key={entryProtocolState.getAllEntryProtocolFilters.attachmentId || 'default'}
                        value={entryProtocolState.getAllEntryProtocolFilters.attachmentId}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllEPFilterAttachmentId(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                </div>
                <div className={"grid grid-cols-2 gap-4"}>
                    <MadfarmStaticSelect
                        isClearable
                        label={"Oggetto"}
                        placeholder={'Seleziona Oggetto'}
                        options={objects}
                        key={entryProtocolState.getAllEntryProtocolFilters.objectId || 'default'}
                        value={entryProtocolState.getAllEntryProtocolFilters.objectId}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllEPFilterObjectId(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                    <MadfarmInput
                        label={'Specifiche Oggetto'}
                        placeholder="Specifiche"
                        value={entryProtocolState.getAllEntryProtocolFilters.objectSpec}
                        onChangeText={(text) => { dispatch(setGetAllEPFilterObjectSpec(text)) }}
                    />
                </div>
                <div className={"flex flex-row gap-1 items-center justify-end"}>
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Pulisci"
                        color={"gray"}
                        onClick={() => {
                            dispatch(resetGetAllEPFilters())
                            setFiltersResetVersion((prev) => prev + 1)
                            dispatch(GetAllEntryProtocols({
                                number: '',
                                client: '',
                                sender: '',
                                objectSpec: '',
                                itemsPerPage: '50',
                                page: 0,
                                sort: "protocolDate",
                                order: false
                            }))
                        }}
                    />
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Cerca'
                        onClick={() => dispatch(GetAllEntryProtocols(entryProtocolState.getAllEntryProtocolFilters))}
                    />
                </div>
            </div>
            <Pagination
                numbResults={entryProtocolState.getAllEntryProtocolsResponse ? entryProtocolState.getAllEntryProtocolsResponse?.data.length : 0}
                detailsResults={'Protocolli'}
                fullWidth={true}
                pages={entryProtocolState.getAllEntryProtocolsResponse?.totalPage || 1}
                currentPage={entryProtocolState.getAllEntryProtocolFilters.page ? entryProtocolState.getAllEntryProtocolFilters.page : 0}
                setPage={
                    (page) => {
                        dispatch(setGetAllEPFilterPage(page))

                    }
                }
            />
            <EntryListProtocol />
        </Layout>
    )
}